import React from 'react';

export default function SpecialityIcon() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_44507_28296)'>
        <path
          d='M8.39034 1.7227C8.14035 1.47263 7.80127 1.33211 7.44767 1.33203H2.66634C2.31272 1.33203 1.97358 1.47251 1.72353 1.72256C1.47348 1.9726 1.33301 2.31174 1.33301 2.66536V7.4467C1.33308 7.80029 1.47361 8.13937 1.72367 8.38937L7.52634 14.192C7.82935 14.4931 8.23917 14.6621 8.66634 14.6621C9.09351 14.6621 9.50333 14.4931 9.80634 14.192L14.193 9.80536C14.4941 9.50236 14.6631 9.09253 14.6631 8.66536C14.6631 8.2382 14.4941 7.82837 14.193 7.52536L8.39034 1.7227Z'
          stroke='#2B7FFF'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M5.00033 5.33464C5.18442 5.33464 5.33366 5.1854 5.33366 5.0013C5.33366 4.81721 5.18442 4.66797 5.00033 4.66797C4.81623 4.66797 4.66699 4.81721 4.66699 5.0013C4.66699 5.1854 4.81623 5.33464 5.00033 5.33464Z'
          fill='#2B7FFF'
          stroke='#2B7FFF'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_44507_28296'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
